import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const GRADIENTS = {
  error: 'linear-gradient(135deg, #ef5350, #c62828)',
  success: 'linear-gradient(135deg, #66bb6a, #2e7d32)',
};

// วงกลม gradient เล็กๆ โชว์ HTTP status code — ใช้ร่วมกันทั้ง GlobalErrorDialog (variant="error" เสมอ)
// และ GlobalAlertDialog (variant ตาม status ที่ caller ส่งมา: มี status = error, ไม่มี = success)
// ไม่มี code จริง (เช่น network error ที่ไม่มี response, หรือ success ที่ไม่มี status โดยธรรมชาติ) —
// error โชว่ "!" แทน, success โชว่ "✓" แทน
export default function StatusCodeBadge({ code, variant = 'error', size = 32 }) {
  const fontSize = code != null && String(code).length > 2 ? size * 0.32 : size * 0.4;
  return (
    <div
      style={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: '50%',
        background: GRADIENTS[variant] || GRADIENTS.error,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 700,
        fontSize,
        lineHeight: 1,
      }}
    >
      {code != null ? (
        code
      ) : variant === 'success' ? (
        <CheckIcon style={{ fontSize: size * 0.55 }} />
      ) : (
        <PriorityHighIcon style={{ fontSize: size * 0.55 }} />
      )}
    </div>
  );
}
